import { defineFcm } from '../shared/factory';

export const FCM_DMI_SERVICE_AUTO_TRIGGER_ENABLED = defineFcm('dmi_service_auto_trigger_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
